import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor( private toastr: ToastrService ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        tap((event) => {
          if (!(event instanceof HttpResponse)) return;

          const body = event.body as { status?: string; mensaje_error?: string } | null;
          if (body?.status === 'error' && !this.estaEnListaIgnorar(request.url)) {
            this.toastr.error(body.mensaje_error ?? 'Ha ocurrido un error.');
          }
        }),
        catchError((error : HttpErrorResponse )=>{
          let mensajeError = '';

          if(!window.navigator.onLine){
            mensajeError =  `Su navegador no esta conectado a internet.`;
          }else{
            mensajeError = error.error.mensaje_error ?? `Ha ocurrido un error.`;
          }

          if(!this.estaEnListaIgnorar(request.url)) this.toastr.error(mensajeError);
          console.error(error);

          return throwError(error.error)
        })
      );
  }

  listaRutasIgnorar: string[] = []

  private estaEnListaIgnorar(url: string): boolean {
    return Boolean(this.listaRutasIgnorar.filter((r) => url.includes(r)).length)
  }
}
